// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__xSK1R","list":"styles_list__1BnmO","disableSelection":"styles_disableSelection__2HOlX"};